import { formatDateTime, toLocalInput, fromLocalInput } from './format.js'

/**
 * When an activity is done again (D-194): a call nobody answered, called again tomorrow, in two
 * days, a week or a month. On a working day (a Saturday or Sunday moves to Monday), at the time
 * of day it was planned for — else at nine.
 */
export const FOLLOW_UPS = ['tomorrow', 'days2', 'week', 'month']

export function followUpAt(choice, activity = {}, now = new Date()) {
  const [y, m, d] = toLocalInput(now.toISOString()).slice(0, 10).split('-').map(Number)
  const planned = toLocalInput(activity.start_at || activity.due_at)
  const time = planned && !activity.all_day ? planned.slice(11, 16) : '09:00'
  const date = new Date(Date.UTC(y, m - 1, d))
  if (choice === 'month') {
    date.setUTCDate(1)
    date.setUTCMonth(date.getUTCMonth() + 1)
    // The 31st has no day in a shorter month: its last day.
    date.setUTCDate(Math.min(d, new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth() + 1, 0)).getUTCDate()))
  } else {
    date.setUTCDate(date.getUTCDate() + ({ tomorrow: 1, days2: 2, week: 7 }[choice] ?? 1))
  }
  while (date.getUTCDay() === 0 || date.getUTCDay() === 6) date.setUTCDate(date.getUTCDate() + 1)
  return fromLocalInput(`${date.toISOString().slice(0, 10)}T${time}`)
}

/** Whether an outcome (a key of activity_outcome) is one after which the activity is done again. */
export const retries = (entries, outcome) => !!outcome && !!(entries || []).find((e) => e.key === outcome)?.meta?.retry

/** What closing said: cancelled, completed, or completed and planned again on that day. */
export const closedText = (t, action, body = {}) => (action === 'cancel' ? t('activity.cancelled')
  : body.follow_up?.at ? t('activity.completedAgain', { date: formatDateTime(body.follow_up.at) }) : t('activity.completed'))
